<div class="slider-container">
  <div class="slider-header">
    <button type="button" class="control-prev" (click)="prevGroup()" *ngIf="photos?.length > 1">
      <nb-icon icon="chevron-left-outline"/>
    </button>

    <div class="slider-viewport">
      <div
        #sliderTrack
        class="slider-track"
        [style.transform]="'translateX(' + (-currentGroupIndex * 100) + '%)'"
      >
        <ng-container *ngFor="let photo of photos; let i = index">
          <div class="slide" style="cursor: inherit" [class.selected-video]="photo.videoCode">
            <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ item: photo, index: i}"/>
          </div>
        </ng-container>
      </div>
    </div>

    <button type="button" class="control-next" (click)="nextGroup()" *ngIf="photos?.length > 1">
      <nb-icon icon="chevron-right-outline"/>
    </button>
  </div>

  <div class="thumbnails" *ngIf="photos?.length > 1">
    <div
      *ngFor="let photo of photos; let i = index"
      class="thumbnail" style="cursor: inherit"
      [class.active]="isThumbnailActive(i)"
      [class.selected-video]="photo.videoCode"
    >
      <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ item: photo, index: i}"/>
    </div>
  </div>
</div>

<ng-template #item let-item="item">
  <img [src]="item.src" alt="">
  <img alt="" class="video-icon" src="/assets/images/product/video.svg" *ngIf="item.videoCode">
</ng-template>

<image-preview #preview [title]="title"/>
